import { __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { classNames, liveAnnounce, Level } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
import { UitkBottomSheet } from './uitk-bottom-sheet.esm.js';
import { UitkSideSheet } from './uitk-side-sheet.esm.js';
import { UitkPopoverSheet } from './uitk-popover-sheet.esm.js';
import { UitkFullSheet } from './uitk-full-sheet.esm.js';
import { UitkCenteredSheet } from './uitk-centered-sheet.esm.js';

var getClassNameList = classNames.bind(styles);
var Sheet = function (props) {
    var _a = props.autoFocus, autoFocus = _a === void 0 ? true : _a, children = props.children, className = props.className, _b = props.isVisible, isVisible = _b === void 0 ? false : _b, liveAnnounceString = props.liveAnnounceString, _c = props.type, type = _c === void 0 ? 'bottom' : _c;
    var baseClassName = 'uitk-sheet';
    var sheetClassNames = getClassNameList(className, baseClassName);
    var announce = function (msg) {
        liveAnnounce(msg, Level.POLITE);
    };
    var Tag;
    switch (type) {
        case 'bottom':
            Tag = UitkBottomSheet;
            break;
        case 'centered':
            Tag = UitkCenteredSheet;
            break;
        case 'full':
            Tag = UitkFullSheet;
            break;
        case 'popover':
            Tag = UitkPopoverSheet;
            break;
        case 'side':
            Tag = UitkSideSheet;
            break;
        default:
            Tag = UitkBottomSheet;
    }
    React.useEffect(function () {
        isVisible && announce(liveAnnounceString);
    }, [isVisible, liveAnnounceString]);
    return (React.createElement(Tag, __assign({}, props, { className: sheetClassNames, autoFocus: autoFocus }), children));
};
var UitkSheet = function (props) {
    var l10n = useLocalization();
    return React.createElement(Sheet, __assign({ l10n: l10n }, props));
};
UitkSheet.displayName = 'UitkSheet';

export { Sheet, UitkSheet };
